import type { AppIconProps } from "../IconTypes";

export const ObjectIcon: React.FC<AppIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 5L7.99996 2L2.66663 5M13.3333 5L7.99996 8M13.3333 5L13.3333 7.26736M7.99996 14L2.66663 11V5M7.99996 14V8M7.99996 14L9.33329 13.25M2.66663 5L7.99996 8"
        stroke="#1D9F81"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 11.4897H14.6666M12.6666 9.48975V13.4897"
        stroke="#1D9F81"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
